// ============================================================================
// ITALIAN TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Fatti affascinanti sulla Bibbia

export const bibleFacts = [
  {
    category: "struttura",
    text: "La Bibbia contiene 66 libri scritti da oltre 40 autori diversi nell'arco di circa 1500 anni",
    source: "Struttura biblica canonica"
  },
  {
    category: "dimensione",
    text: "La Bibbia contiene 31.173 versetti, 1.189 capitoli e circa 783.137 parole nella sua versione originale",
    source: "Analisi testuale biblica"
  },
  {
    category: "traduzione",
    text: "La Bibbia è stata tradotta completamente o parzialmente in oltre 3.000 lingue, rendendola il libro più tradotto al mondo",
    source: "Società Bibliche Unite"
  },
  {
    category: "versetto",
    text: "Il versetto più corto della Bibbia è 'Gesù pianse' (Giovanni 11:35), mentre il più lungo è Ester 8:9",
    source: "Analisi testuale biblica"
  },
  {
    category: "popolarità",
    text: "La Bibbia è il libro più venduto di tutti i tempi, con oltre 5 miliardi di copie distribuite",
    source: "Registri editoriali"
  },
  {
    category: "storia",
    text: "I Rotoli del Mar Morto, scoperti nel 1947, contengono manoscritti biblici datati oltre 2.000 anni fa",
    source: "Archeologia biblica"
  },
  {
    category: "centro",
    text: "Il capitolo centrale della Bibbia è il Salmo 118, e il versetto centrale è il Salmo 118:8",
    source: "Struttura numerica biblica"
  }
];

export default bibleFacts;
